import en from './en.json';
import fr from './fr.json';

export default { en, fr };

declare global {
  interface RegisteredLocales {
    common: typeof en | typeof fr;
  }
}
